export default __webpack_public_path__ + "static/media/categories.e9b20aa2.yaml";